// Imports
import { Component, ViewChild } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { APPCONFIG } from '../config';
import { SessionHandler } from '../shared/services/session-handler.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
//import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import { ChangeEvent } from '@ckeditor/ckeditor5-angular/ckeditor.component';

// Component Decorator
@Component({
    template: require('./translation-email.component.html'),
    styles: [require('../../app/newCommon.scss')],
})

// Component Class
export class TranslationEmailComponent {
    responseLanguageId: any;
    ProfileForm: FormGroup;
    LanguageData: any;
    userDetails: any;
    profileData: any;
    //public Editor = ClassicEditor;
    emailBody: string = "";
    emailSubject: string;
    isSystemAdmin: boolean = false;
    isApplicationManager: boolean = false;
    isBUManager: boolean = false;
    isRegionalAdmin: boolean = false;
    isServiceOwner: boolean = false;
    isTradePartner: boolean = false;
    isSubUser: boolean = false;
    
    constructor(public httpService: HttpService, private formBuilder: FormBuilder, public sessionHandler: SessionHandler,
    ) {
        APPCONFIG.navCollapsed = true;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }
        if (this.isSystemAdmin) {
        this.getlanguages();
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        this.profileData = this.userDetails;
        if (this.profileData.languageId) {
            this.setLanguage(this.profileData.languageId);
        }
        this.getSubjectList();
    }
    }
    public setLanguage(languageId) {
        this.responseLanguageId = languageId;
        this.buildForm();
    }
    buildForm() {
        this.ProfileForm = this.formBuilder.group({
            languageId: this.formBuilder.control(this.responseLanguageId, [Validators.required])
        });
    }
    public getlanguages() {
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(
            res => { this.savelanguageResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    //Save languages Response
    public savelanguageResponse(res) {

        if (res && res.items) {
            this.LanguageData = res.items;
        }
        
    }
    langId;
    onLanguageChange(languageId) {
        this.j = undefined;
        this.responseLanguageId = languageId;
        this.getSubjectList();
        
        this.j = undefined;
    }
    j;
    selectEmail(data, i) {
        console.log(i);
        console.log(data);
        if (this.j != i) {
            if (this.j != undefined ) {
                document.getElementById(this.j).setAttribute("class", "style2, mdl-tabs__tab");
            }
            document.getElementById(i).setAttribute("class", "style1");
        }
        this.j = i;
        this.emailSubject = data.text;
        this.getEmailBodyList(data);
    }
    SubjectData;
    SubjectItems;
    getSubjectList() {
        const st = this.j;
        this.httpService.getRequest("superUserOperationsApi/v1/multilingualEmailSubject/list/" + this.responseLanguageId).subscribe(
            res => {
                console.log(res);
                this.SubjectData = res;
                this.SubjectItems = this.SubjectData.items;
            },
            err => {
                this.httpService.onEnd();
            });
            if(st){
            setTimeout(() => {
                for(let i in this.SubjectItems){
                    if(st == this.SubjectItems[i].id){
                     document.getElementById(this.SubjectItems[i].id).setAttribute("class", "style1");
                    }}
                    this.httpService.onEnd();
              }, 3000);
            } else{
              setTimeout(() => {
                if(this.SubjectItems){
                    this.selectEmail(this.SubjectItems[0], this.SubjectItems[0].id)
                }
              }, 3000);}
            
            /* if(st){
                for(let i in this.SubjectItems){
                    if(st == this.SubjectItems[i].id){
                     document.getElementById(this.SubjectItems[i].id).setAttribute("class", "style1");
                    }
                }
            } */
    }
    emailBodyData;
    emailBodyid;
    emailSubjectid;
    getEmailBodyList(key) {
        this.emailSubjectid = key.id;
        this.httpService.getRequest("superUserOperationsApi/v1/multilingualEmail/"+this.responseLanguageId+"?key=" + key.key).subscribe(
            res => {
                console.log(res);
                this.emailBodyData = res;
                this.emailBody = this.emailBodyData.html;
                this.emailBodyid = this.emailBodyData.id;
                this.httpService.onEnd();
            },
            err => {
                this.httpService.onEnd();
            });
    }
    updatedSubject = {};
    updatedSubjectId;
    updateSubject() {
        
        console.log(this.emailSubject);
        var body = {
            id: this.emailSubjectid,
            text: this.emailSubject
        }
        this.httpService.postRequest(body, 'superUserOperationsApi/v1/multilingualEmailSubject').subscribe(
            res => {
                console.log(res);
                this.getSubjectList();
                this.updatedSubject = res;
            },
            err => { this.httpService.onEnd(); }
        );
    }
    AdminFormDetails: any;
    updateBody() {
        console.log(this.emailBody);
        var body = {
            id: this.emailBodyid,
            html: this.emailBody
        }
        this.httpService.postRequest(body, 'superUserOperationsApi/v1/multilingualEmail').subscribe(
            res => {
                console.log(res);
                this.httpService.onEnd();
            },
            err => { this.httpService.onEnd(); }
        );

    }




} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/translation-email/translation-email.component.ts